module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-16.b9b2fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-16.jpg
// module id = Ls03
// module chunks = 52